import React from 'react'
import BaseGraphLine from '../BaseGraphLine'

const MissedLine = ({ coordinates }) => (
  <BaseGraphLine
    {...coordinates}
    strokeDasharray="2, 5"
    strokeLinecap="square"
    style={{
      stroke: '#c5cbd4',
      strokeWidth: 2,
    }}
  />
)

MissedLine.displayName = 'MissedLine'

export default MissedLine
